/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

function formatProfileData (user) {
  if (user) {
    user.fname = user.fname ? user.fname.trim() : null;
    user.mname = user.mname ? user.mname.trim() : null;
    user.lname = user.lname ? user.lname.trim() : null;
    user = setFullName(user);
    user.status = parseInt(user.status);
    user.vmrenabled =
      user.vmrenabled === '1' ||
      user.vmrenabled === 1 ||
      user.vmrenabled === true;
    user.hasendpoint =
      user.myendpoint && user.myendpoint.trim().length > 0;
  }
  return user;
}
function setFullName (user, state) {
  user.fullname = '';
  if (user) {
    user.fullname = user.fname ? user.fname.trim() : '';
    user.fullname += user.mname ? ' ' + user.mname.trim() : '';
    user.fullname += user.lname ? ' ' + user.lname.trim() : '';
    user.fullname = user.fullname.trim();
  }
  return user;
}
export default {
  namespaced: true,
  state: {
    autoAnswerFav: false,
    profile: null,
    errorReason: null,
    isValid: false,
    token: null,
    rememberedUsername: null,
    rememberedPassword: null
  },
  getters: {
    autoAnswerFav (state) {
      return state.autoAnswerFav;
    },
    profile (state) {
      return state.profile;
    },
    errorReason (state) {
      return state.errorReason;
    },
    isValid (state) {
      return state.isValid;
    },
    token (state) {
      return state.token;
    },
    rememberedUsername (state) {
      return state.rememberedUsername;
    },
    rememberedPassword (state) {
      return state.rememberedPassword;
    }
  },
  mutations: {
    setAutoAnswerFav (state, status) {
      state.autoAnswerFav = status;
    },
    isValid (state, isValid) {
      state.isValid = isValid;
    },
    setToken (state, token) {
      state.token = token;
    },
    setUser (state, user) {
      state.profile = formatProfileData(user);
    },
    updateProfile (state, update) {
      update = formatProfileData({ ...state.profile, ...update });
      state.profile = update;
    },
    setRememberedUsername (state, username) {
      state.rememberedUsername = username;
    },
    setRememberedPassword (state, password) {
      state.rememberedPassword = password;
    }
  },
  actions: {
    setAutoAnswerFav ({ commit }, status) {
      commit('setAutoAnswerFav', status);
    },
    isValid ({ commit }, isValid) {
      commit('isValid', isValid);
    },
    loginSuccess ({ commit }, { token }) {
      commit('setToken', token);
      commit('ContactStore/setPresence', { presence: [], isgroup: true }, { root: true });
    },
    logoutUser ({ commit }) {
      commit('setUser', null);
      commit('setToken', null);
      commit('isValid', false);
      commit('setAutoAnswerFav', false);
    },
    setProfile ({ commit }, profile) {
      commit('setUser', profile);
    },
    updateProfile ({ commit }, profile) {
      commit('updateProfile', profile);
    },
    setRememberedUsername ({ commit }, username) {
      commit('setRememberedUsername', username);
    },
    setRememberedPassword ({ commit }, password) {
      commit('setRememberedPassword', password);
    }
  }
};
